import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs/Observable";
import { Subscription } from "rxjs/Subscription";
import { TAAConstants } from "../../constants/taa-constants";
import { AccommsService } from "../../services/accomms.service";
import { AppService } from "../../services/app.service";
import { LoggerService } from "../../services/audit-logger.service";
import { CommonService } from "../../services/common.service";
import { HeaderService } from "../../services/header.service";
import { PlanService } from "../../services/plan.service";
import { RequestSubmitService } from "../../services/requestsubmit.service";
import { User } from "../../services/user.model";
import { StepperComponent } from "../stepper/stepper.component";


@Component({
  selector: "app-plan",
  templateUrl: "./plan.component.html",
  styleUrls: ["./plan.component.css"]
})
export class PlanComponent implements OnInit, OnDestroy {
  public personName: string;
  public taaPin: string;
  public planTypeDiv: boolean = false;
  public savedPlanId: string = "";
  public savedPlanDuration: string = "";
  public savedAccomsPesronId: string;
  public savedEllPesronId: string;
  public savedEllPlan: string = "";
  public savedPublic: string = "";
  public fourmoDiv: boolean = false;
  public oneyearDiv: boolean = false;
  public planDuration: string;
  public planOptions: Array<any> = [];
  public data: any;
  public ellValue: any;
  public publicValue: any;
  public planId: any;
  public ellPlainId: any;
  public selectedPlanDuration: any;
  public planYear: string;
  public accommodationPlan: boolean = false;
  public exceptionFlag: boolean = false;
  public ellSupportDiv: boolean = false;
  public publicDiv: boolean = false;
  public errorMsg: boolean = false;
  public ellSupport: boolean = false;
  public ellPlanFlag: boolean = false;
  public publicPlanFlag: boolean = false;
  public planDurationFlag: boolean = false;
  public planFourMonthFlag: boolean = false;
  public planOneYearFlag: boolean = false;
  public showaccommodationPlan: boolean = false;
  public showPlanTypeDiv: boolean = false;
  public showEllDiv: boolean = false;
  public showPublicDiv: boolean = false;
  public currentRecord: any;
  public selectedOrg: any;
  public loading: boolean = true;
  public successMessage: boolean;
  public errorMessage: boolean;
  public enableSaveContinue: boolean = false;
  public userProfile: User;
  private subscriptions: Array<Subscription> = [];
  public isLoading: boolean = false;
  public personPlanIds: Array<any> = [];
  public planReconsideration: string;
  public auditStatusText: string = "";
  public auditLogCategory: string = "";
  public statusCd: string;
  recordCount = "0";
  @ViewChild('openModal') openModal: ElementRef;

  constructor(
    public headerService: HeaderService,
    public stepper: StepperComponent,
    public router: Router,
    private appService: AppService,
    public planService: PlanService,
    public commonService: CommonService,
    public taaConstants: TAAConstants,
    private _loggerService: LoggerService,
    public requestSubmitService: RequestSubmitService,
    private accommsService: AccommsService
  ) { }
  ngOnInit() {
    sessionStorage.setItem("reasonSubmitted", "");
    this.isLoading = true;
    this.currentRecord = this.stepper.getPreviousRecordDetails();
    this.selectedOrg = this.headerService.getselectedOrgDetails();
    this.taaPin = this.currentRecord.taaPin;
    this.personName = this.stepper.request
      ? this.stepper.request.personName
      : "";
    // this.getStatusCode();
    if (this.currentRecord) {
      Observable.forkJoin(
        this.commonService.getFinishedRecordCount(this.currentRecord.personId),
        this.planService.getPersonPlanById(this.currentRecord.personId)
      )
        .finally(() => {
          this.isLoading = false;
        })
        .subscribe(([finishedRecordCount, response]) => {
          if (finishedRecordCount === "1") {
            this.recordCount = "1";
          } else if (finishedRecordCount === "error") {
            this.openModal.nativeElement.click();
          }
          // this.recordCount = finishedRecordCount as any;
          if (response) {
            const personPlan: any = response.body;
            this.enableSaveContinue = true;
            Observable.forkJoin(this.planService.getPlan()).subscribe(resp => {
              if (resp) {
                this.data = resp[0].body;
                for (let i = 0; i < personPlan.length; i++) {
                  this.personPlanIds.push(personPlan[i].PLAN_ID);
                  if (
                    (personPlan[i].RECV_ELL_SUPP_IN_SCH === null || personPlan[i].RECV_ELL_SUPP_IN_SCH.trim() === "") &&
                    personPlan[i].YEARS_ON_PLAN_NO === "<4"
                  ) {
                    this.savedAccomsPesronId = personPlan[i].PERSON_PLAN_ID;
                    this.planDuration = "4 Months";
                    this.savedPlanId = personPlan[i].PLAN_ID;
                    this.planFourMonthFlag = true;
                    this.fourmoDiv = true;
                    this.savedPlanDuration = "Less Than 4 Months";
                  } else if (
                    (personPlan[i].RECV_ELL_SUPP_IN_SCH === null || personPlan[i].RECV_ELL_SUPP_IN_SCH.trim() === "") &&
                    personPlan[i].YEARS_ON_PLAN_NO === "=>4"
                  ) {
                    this.savedAccomsPesronId = personPlan[i].PERSON_PLAN_ID;
                    this.planDuration = "4 Months";
                    this.savedPlanId = personPlan[i].PLAN_ID;
                    this.planFourMonthFlag = true;
                    this.fourmoDiv = true;
                    this.savedPlanDuration = "4 Months or More";
                  } else if (
                    (personPlan[i].RECV_ELL_SUPP_IN_SCH === null || personPlan[i].RECV_ELL_SUPP_IN_SCH.trim() === "") &&
                    personPlan[i].YEARS_ON_PLAN_NO === "<1"
                  ) {
                    this.savedAccomsPesronId = personPlan[i].PERSON_PLAN_ID;
                    this.planDuration = "Twelve Calendar Months";
                    this.savedPlanId = personPlan[i].PLAN_ID;
                    this.planOneYearFlag = true;
                    this.oneyearDiv = true;
                    this.savedPlanDuration = "Less Than Twelve Calendar Months";
                  } else if (
                    (personPlan[i].RECV_ELL_SUPP_IN_SCH === null || personPlan[i].RECV_ELL_SUPP_IN_SCH.trim() === "") &&
                    personPlan[i].YEARS_ON_PLAN_NO === "=>1"
                  ) {
                    this.savedAccomsPesronId = personPlan[i].PERSON_PLAN_ID;
                    this.planDuration = "Twelve Calendar Months";
                    this.savedPlanId = personPlan[i].PLAN_ID;
                    this.planOneYearFlag = true;
                    this.oneyearDiv = true;
                    this.savedPlanDuration = "Twelve Calendar Months or More";
                  } else if (
                    personPlan[i].RECV_ELL_SUPP_IN_SCH === "Y" &&
                    personPlan[i].YEARS_ON_PLAN_NO === "NA"
                  ) {
                    this.savedEllPesronId = personPlan[i].PERSON_PLAN_ID;
                    this.savedEllPlan = "Yes";
                    this.ellPlanFlag = true;
                  } else if (
                    personPlan[i].RECV_ELL_SUPP_IN_SCH === "N" &&
                    personPlan[i].YEARS_ON_PLAN_NO === "NA"
                  ) {
                    this.savedEllPesronId = personPlan[i].PERSON_PLAN_ID;
                    this.savedEllPlan = "No";
                    this.ellPlanFlag = true;
                  } else if (
                    (personPlan[i].RECV_ELL_SUPP_IN_SCH === null || personPlan[i].RECV_ELL_SUPP_IN_SCH.trim() === "") &&
                    personPlan[i].YEARS_ON_PLAN_NO === "NONE"
                  ) {
                    this.savedAccomsPesronId = personPlan[i].PERSON_PLAN_ID;
                    this.planTypeDiv = false;
                    this.exceptionFlag = true;
                    this.savedPlanId = personPlan[i].PLAN_ID;
                  } else {
                    this.savedAccomsPesronId = personPlan[i].PERSON_PLAN_ID;
                    this.planTypeDiv = false;
                    this.savedPlanId = personPlan[i].PLAN_ID;
                  }
                }
                for (let i = 0; i < this.data.length; i++) {
                  if (this.data[i].PLAN_NM !== "ELLPLAN") {
                    if ((this.selectedOrg.publicCode === "Y")
                      && (this.data[i].PLAN_NM === "IEP"
                        || this.data[i].PLAN_NM === "504"
                        || this.data[i].PLAN_NM === "Exceptions Statement")) {
                      this.planOptions.push(this.data[i]);
                    }
                    if ((this.selectedOrg.publicCode === "N")
                      && !(this.data[i].PLAN_NM === "IEP"
                        || this.data[i].PLAN_NM === "504")) {
                      this.planOptions.push(this.data[i]);
                    }

                  } else if (this.data[i].PLAN_NM === "ELLPLAN") {
                    this.ellPlainId = this.data[i].PLAN_ID;
                  }
                  if ((this.savedPlanId !== "" && this.data[i].PLAN_ID === this.savedPlanId)
                    && (this.data[i].PLAN_NM === "IEP" || this.data[i].PLAN_NM === "504")) {
                    this.publicDiv = true;
                    this.exceptionFlag = false;
                  } else if ((this.savedPlanId !== "" && this.data[i].PLAN_ID === this.savedPlanId)
                    && (this.data[i].PLAN_NM === "Exceptions Statement")) {
                    this.exceptionFlag = true;
                  }
                }
                Observable.forkJoin(
                  this.planService.getRequest(this.currentRecord)
                ).subscribe(res => {
                  if (res) {
                    const result: any = res[0].body;
                    if (result[0].REQ_TYP_ACCOM_FL === "Y") {
                      this.accommodationPlan = true;
                      this.isLoading = false;
                      if (this.selectedOrg.publicCode === "Y") {
                        this.planTypeDiv = false;

                      } else {
                        this.publicDiv = false;
                        this.planTypeDiv = true;
                      }
                      if (result[0].RECV_ACCOMM_IN_SCH === "Y") {
                        this.savedPublic = "Yes"
                      } else if (result[0].RECV_ACCOMM_IN_SCH === "N") {
                        this.savedPublic = "No"
                      }

                    } else {
                      this.publicDiv = false;
                      for (let j = 0; j < this.personPlanIds.length; j++) {
                        if (this.personPlanIds[j] !== this.ellPlainId) {
                          const data = {
                            PERSON_ID: this.currentRecord.personId,
                            PLAN_ID: this.personPlanIds[j]
                          };
                          Observable.forkJoin(this.planService.deletePlan(data))
                            .finally(() => { })
                            .subscribe(deletePlan => { });
                        }
                      }
                    }

                    if (result[0].REQ_TYP_ELL_SUPP_FL === "Y") {
                      this.isLoading = false;
                      this.ellSupportDiv = true;
                    } else if (result[0].REQ_TYP_ELL_SUPP_FL === "N") {
                      for (let j = 0; j < this.personPlanIds.length; j++) {
                        if (this.personPlanIds[j] === this.ellPlainId) {
                          const data = {
                            PERSON_ID: this.currentRecord.personId,
                            PLAN_ID: this.personPlanIds[j]
                          };
                          Observable.forkJoin(this.planService.deletePlan(data))
                            .finally(() => { })
                            .subscribe(deletePlan => { });
                        }
                      }
                    }
                  }
                });
              }
            });
          }
        });
    }
    Observable.forkJoin(
      this.commonService.getDynContent(
        "REQUEST_STATUS_UPDATED_TO_RECONSIDER_MSG"
      )
    ).subscribe(([planReconsideration]) => {
      this.planReconsideration = planReconsideration;
    });
    this.getStatusCode();
    this.appService.getUserProfile().then(user => (this.userProfile = user));
  }
  gotoHome() {
    setTimeout(() => {
      this.router.navigate(["/examinees"]);
    }, 500);
  }
  ngOnDestroy() {
    for (const o of this.subscriptions) {
      o.unsubscribe();
    }
  }

  savePlanData = navigate => {
    if (!this.savedPlanId && this.accommodationPlan) {
      this.errorMsg = true;
      this.showaccommodationPlan = true;
    } else if (this.publicDiv && !this.savedPublic) {
      this.errorMsg = true;
      this.showPublicDiv = true;
    } else if (this.ellSupportDiv && !this.savedEllPlan) {
      this.errorMsg = true;
      this.showEllDiv = true;
    } else {
      this.isLoading = true;
      this.submitResult()
        .finally(() => {
          this.isLoading = false;
        })
        .subscribe(response => {
          if (this.recordCount !== "0") {
            Observable.forkJoin(
              this.requestSubmitService.getRequestStatusCodeIdByNm(
                this.taaConstants.getRECONSIDER_INCOMPLETE()
              )
            ).subscribe(([submitStatus]) => {
              const updateRequest = {
                PERSON_ID: this.stepper.request.personId,
                REQUEST_ID: this.stepper.request.requestId,
                REQUEST_STATUS_CODE_ID: submitStatus[0].REQUEST_STATUS_CODE_ID
              };
              Observable.forkJoin(
                this.commonService.updateRequestForReconsider(updateRequest)
              ).subscribe(
                success => {
                  if (navigate) {
                    this.auditStatusText =
                      "Request updated on Plan Page from Complete to ReconsiderIncomplete ";
                    this.auditLogCategory = "STATUS_CHANGE";
                    this.updateLogs();
                    sessionStorage.setItem("planSubmitted", "true");
                    this.stepper.goToNextStep();
                  }
                },
                err => {
                  console.log(err);
                }
              );
            });
          } else {
            if (navigate) {
              if (
                this.statusCd === this.taaConstants.getRECONSIDER_INCOMPLETE()
              ) {
                this.auditStatusText = "Request updated on Plan Page ";
                this.auditLogCategory = "REQUEST_CHANGE";
                this.updateLogs();
              }
              sessionStorage.setItem("planSubmitted", "true");
              this.stepper.goToNextStep();
            }
          }
        });
    }
  }
  getStatusCode() {
    this.accommsService
      .getRequests(this.currentRecord.requestId)
      .subscribe((data: any) => {
        this.accommsService
          .getRequestedStatusCode(data[0].REQUEST_STATUS_CODE_ID)
          .subscribe((success: any) => {
            this.statusCd = success[0].STATUS_CD;
          });
      });
  }
  public submitResult(): Observable<any> {
    const obj = {
      PERSON_ID: this.currentRecord.personId,
      CREATED_BY_DS: this.userProfile.userName,
      UPDATED_BY_DS: this.userProfile.userName,
      LOCKED_FL: 0
    };
    const updateRequest = {
      PERSON_ID: this.currentRecord.personId,
      UPDATED_BY_DS: this.userProfile.userName,
      REQUEST_ID: this.currentRecord.requestId,
      REQUEST_STATE_TX: "4",
      RECV_ACCOMM_IN_SCH: this.publicValue
    };
    if (
      (this.accommodationPlan && this.ellSupportDiv) ||
      this.accommodationPlan ||
      this.ellSupportDiv
    ) {
      const personAccomPlan = JSON.parse(JSON.stringify(obj));
      personAccomPlan["PLAN_ID"] = this.planId;
      personAccomPlan["YEARS_ON_PLAN_NO"] = this.selectedPlanDuration;
      personAccomPlan["RECV_ELL_SUPP_IN_SCH"] = "";

      const personEllPlan = JSON.parse(JSON.stringify(obj));
      personEllPlan["PLAN_ID"] = this.ellPlainId;
      personEllPlan["YEARS_ON_PLAN_NO"] = "NA";
      personEllPlan["RECV_ELL_SUPP_IN_SCH"] = this.ellValue;

      const updatePersonAccomPlan = {
        PERSON_PLAN_ID: this.savedAccomsPesronId,
        PERSON_ID: this.currentRecord.personId,
        PLAN_ID: this.planId,
        UPDATED_BY_DS: this.userProfile.userName,
        YEARS_ON_PLAN_NO: this.selectedPlanDuration,
        RECV_ELL_SUPP_IN_SCH: ""
      };
      const updatePersonEllPlan = {
        PERSON_PLAN_ID: this.savedEllPesronId,
        PERSON_ID: this.currentRecord.personId,
        PLAN_ID: this.ellPlainId,
        UPDATED_BY_DS: this.userProfile.userName,
        YEARS_ON_PLAN_NO: "NA",
        RECV_ELL_SUPP_IN_SCH: this.ellValue
      };
      if (this.accommodationPlan && this.ellSupportDiv) {
        if (this.savedAccomsPesronId && this.savedEllPesronId) {
          return Observable.forkJoin(
            this.planService.updatePersonPlan(updatePersonAccomPlan),
            this.planService.updatePersonPlan(updatePersonEllPlan),
            this.planService.updateRequest(updateRequest)
          );
        } else if (this.savedAccomsPesronId && !this.savedEllPesronId) {
          return Observable.forkJoin(
            this.planService.updatePersonPlan(updatePersonAccomPlan),
            this.planService.postPersonPlan(personEllPlan),
            this.planService.updateRequest(updateRequest)
          );
        } else if (!this.savedAccomsPesronId && this.savedEllPesronId) {
          return Observable.forkJoin(
            this.planService.postPersonPlan(personAccomPlan),
            this.planService.updatePersonPlan(updatePersonEllPlan),
            this.planService.updateRequest(updateRequest)
          );
        } else {
          return Observable.forkJoin(
            this.planService.postPersonPlan(personAccomPlan),
            this.planService.postPersonPlan(personEllPlan),
            this.planService.updateRequest(updateRequest)
          );
        }
      } else if (this.accommodationPlan) {
        if (this.savedAccomsPesronId) {
          return Observable.forkJoin(
            this.planService.updatePersonPlan(updatePersonAccomPlan),
            this.planService.updateRequest(updateRequest)
          );
        } else {
          return Observable.forkJoin(
            this.planService.postPersonPlan(personAccomPlan),
            this.planService.updateRequest(updateRequest)
          );
        }
      } else if (this.ellSupportDiv) {
        if (this.savedEllPesronId) {
          return Observable.forkJoin(
            this.planService.updatePersonPlan(updatePersonEllPlan),
            this.planService.updateRequest(updateRequest)
          );
        } else {
          return Observable.forkJoin(
            this.planService.postPersonPlan(personEllPlan),
            this.planService.updateRequest(updateRequest)
          );
        }
      }
    }
    return Observable.empty();
  }
  goToReason = () => {
    this.stepper.goToPrevStep();
  }
  public planSelected(selectedPlan) {
    this.errorMsg = false;
    this.showaccommodationPlan = false;
    this.savedPlanDuration = "";
    this.planId = selectedPlan.PLAN_ID;
    if (selectedPlan.PLAN_NM === "IEP" || selectedPlan.PLAN_NM === "504") {
      this.publicDiv = true;
    }
    this.enableSaveContinue = false;
    if (selectedPlan.PLAN_TYPE === "4MO" || selectedPlan.PLAN_TYPE === "1YR") {
      this.planTypeDiv = true;
      this.exceptionFlag = false;
      if (selectedPlan.PLAN_TYPE === "4MO") {
        this.oneyearDiv = false;
        this.planDuration = "4 Months";
        this.fourmoDiv = true;
      } else {
        this.fourmoDiv = false;
        this.planDuration = "Twelve Calendar Months";
        this.oneyearDiv = true;
      }
    } else if (selectedPlan.PLAN_TYPE === "NONE") {
      this.selectedPlanDuration = "NONE";
      this.exceptionFlag = true;
      this.publicDiv = false;
      this.planTypeDiv = false;
    } else {
      this.planTypeDiv = false;
    }
  }
  public selectedEllPlan(ellPlan) {
    this.errorMsg = false;
    this.showEllDiv = false;
    if (ellPlan === "Yes") {
      this.ellValue = "Y";
      this.ellPlanFlag = true;
    } else if (ellPlan === "No") {
      this.ellValue = "N";
      this.ellPlanFlag = true;
    }
  }

  public selectedPublic(publicPlan) {
    this.errorMsg = false;
    this.showPublicDiv = false;
    if (publicPlan === "Yes") {
      this.publicValue = "Y";
      this.publicPlanFlag = true;
    } else if (publicPlan === "No") {
      this.publicValue = "N";
      this.publicPlanFlag = true;
    }
  }

  public onSelectedPlanDuration(planDuration, prm) {
    this.errorMsg = false;
    this.showPlanTypeDiv = false;
    if (prm === "months") {
      this.planFourMonthFlag = true;
      this.planOneYearFlag = false;

      this.selectedPlanDuration =
        planDuration === "4 Months or More" ? "=>4" : "<4";
    } else {
      this.planFourMonthFlag = false;
      this.planOneYearFlag = true;

      this.selectedPlanDuration =
        planDuration === "Twelve Calendar Months or More" ? "=>1" : "<1";
    }
  }

  updateLogs() {
    const loggerModel = {
      MODULE_ID: "REQUEST",
      CATEGORY_ID: this.auditLogCategory,
      COMPONENT_ID: "REQUEST_PLAN_PAGE",
      CREATED_BY_DS: this.userProfile.userName,
      MESSAGE_TX: this.auditStatusText,
      REFERENCE_ID: this.stepper.request.personId,
      SEVERITY_VAL: "",
      UPDATED_BY_DS: this.userProfile.userName,
      USER_DATA_VAL: this.userProfile.userName
    };
    this._loggerService.updateLog(loggerModel).subscribe(
      success => { },
      err => {
        console.log(err);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./client/views/request/plan/plan.component.ts